import './Header.css'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { memo } from 'react'

import { ReactComponent as Back } from '../../icon/back.svg'
import { ReactComponent as Settings } from '../../icon/settings.svg'
import { ReactComponent as Translation } from '../../icon/translation.svg'
import { ReactComponent as Info } from '../../icon/info-blue.svg'

function HeaderComponent(props) {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const goToSettings = _ => {
		navigate(`${props?.location.pathname}/settings`)
	}

	const goToInfo = _ => {
		navigate('/info')
	}

	return (
		<header className="header__container">
			<div className="header__wrapper">
				<div className="icon__container">
					{
						props?.backButton ? 
							props?.backButtonPatch ?
								<Back className="back-icon" onClick={() => navigate(props?.backButtonPatch)} />
								:
								<Back className="back-icon" onClick={() => navigate(-1)} />
							: 
							null
					}
				</div>

				{
					props?.title ?
						<h1 className="header__title">
							{ t(props?.title) }
						</h1>
						:
						props?.subtitle ?
							<h1 className="header__title">
								{ t(props?.subtitle) }
							</h1>
							: 
							null
				}

				<div className="icon__container">
					{
						props?.settingsButton ?
							<Settings className="settings-icon" onClick={goToSettings} />
							:
							props?.translation ?
								<Translation onClick={props?.openTranslator} className="translation-icon" />
								: 
								props?.info ?
									<Info onClick={goToInfo} className="info-icon" />
									:
									null
					}
				</div>
			</div>

			<div className={props.structure ? 'header__subcontainer--grid' : 'header__subcontainer'}>
				{
					props?.title && props?.subtitle ?
						<h2 className="header__subtitle">
							{ t(props?.subtitle) }
						</h2>
						: 
						null
				}
			</div>
		</header>
	)
}

export const Header = memo(HeaderComponent)